export default __webpack_public_path__ + "static/media/mau_dau.83fe712d.svg";